<p-dialog 
      [(visible)]="isVisible" 
      [modal]="true" 
      styleClass="merge_popup"
      position="center" 
      [style]="{ width: '90vw', maxWidth: '1000px' }"
      [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
      [contentStyle]="{ 'overflow': 'hidden', 'border-radius': 0 }" 
      class="merge-dialog"
      (onHide)="onCancelClick()">
      
      <p-header style="text-align: center;">
        <label style="font-size: 17px;">{{ headerText }}</label>
      </p-header>
      
      <div class="col-12" *ngIf="selectedBookingForMerge">

        <div class="eligible-bookings-section">
          <app-mi-grid-v2 
            (totalCount)="totalCount($event)"
            [url]="mergeBookingsUrl" 
            [columnDefs]="mergeColumns" 
            (rowClickedEvent)="onMergeBookingSelect($event)" 
            (mergeCheckboxClicked)="onMergeCheckboxClicked($event)"
            (allMergeCheckboxClicked)="onMergeSelectAllClicked($event)"
            rowSelection="multiple"
            [searchPlaceHolder]="searchPlaceHolder"
            [gridScrollHeight]="'60vh'"
            divClass="mi-grid" [uniqId]="uniqId">
          </app-mi-grid-v2>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="form-buttons col-12">
          <button pButton appRipple type="button" 
            [label]="'label_merge_booking' | translate" 
            [disabled]="isActionDisabled"
            (click)="onMerge()">
          </button>
          <button pButton appRipple type="button" 
            [label]="'label_cancel' | translate" 
            class="negative-button"
            (click)="onCancelClick()">
          </button>
        </div>
      </ng-template>
    </p-dialog>